<template>

  <div class="video-player">
    <video :ref="reference" width="100%" controls :id="reference">
      <source :src="src" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>

</template>

<script>

  import _ from 'underscore'

export default {
    props: ['src', 'reference'],
   
    data() {
      return {
        autoPlay: false,
      }
    },
    mounted() {
      setTimeout(() => {
        this.autoPlay = true;
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
      }, 1000);

      const self = this;
      document.getElementById(this.reference).onpause = function () {
        self.autoPlay = false;
      };
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll() {
        if (this.autoPlay) {
          const padding = 100;
          const scrollTop = $(document).scrollTop();
          const windowHeight = $(window).height();
          const height = $('#' + this.reference).height();
          const top = $('#' + this.reference).offset().top;
          const bottom = top + height;

          const visible = ((top < (windowHeight + scrollTop - padding)) && (top > (scrollTop - height + padding)));

          if (visible) {
            this.$refs[this.reference].play()
          } else {
            this.$refs[this.reference].pause()
          }
        }
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .ad-block { background: #FFFFFF; text-align:center;margin:0px auto;}
  .be-content .ad-block, .left-sidebar-content .ad-block { background: none; }

  @media (max-width: 780px) {
    .ad-block a.side-by-side { float: none; width: 100%; }
    .ad-block a:first-child {padding-bottom:20px;}
  }

  .no-pad .ad-wrap {margin:0px;} 
  .no-pad .ad-wrap a { padding: 0px; }

  .test { background: #DD0000; width: 100%; height: 100px; }
</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?aaf06bf8